import { useEffect, useRef } from 'react';

export function useRealTimeInterval(
  isActive: boolean,
  intervalMinutes: number | null | undefined,
  onInterval: () => void,
  enabled: boolean = true
): void {
  // Use ref to always have the latest callback without triggering re-renders
  const callbackRef = useRef(onInterval);

  useEffect(() => {
    callbackRef.current = onInterval;
  }, [onInterval]);

  useEffect(() => {
    // Early exit if not active, no interval set, or disabled
    if (!isActive || !intervalMinutes || !enabled) {
      return;
    }

    // Convert minutes to milliseconds
    const intervalMs = intervalMinutes * 60 * 1000;

    const intervalId = window.setInterval(() => {
      callbackRef.current();
    }, intervalMs);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isActive, intervalMinutes, enabled]);
}
